<script>
  import Work from "./Work.svelte";
  import ExpandButton from "./ExpandButton.svelte";
  import SetupWrapper from "./SetupWrapper.svelte";
  import Actions from "./Actions.svelte";
  import BackToQuickstart from "./BackToQuickstart.svelte";
  import Container from "./Container.svelte";
  import Prepare from "./Prepare.svelte";
  import Name from "./Name.svelte";
  import { getSetupFromURL } from "../utils/parseUrl";
  export let setup;
  export let urlParams;

  let placeholder =
    'e.g. "Murph" (for time)\n- mile run\n- 100 pull-ups\n- 200 push-ups\n- 300 squats\n- mile run';

  let isSetupExapnded = false;

  isSetupExapnded = getSetupFromURL(urlParams, setup);

  function expandSetup() {
    isSetupExapnded = true;
    setup.isExpanded = true;
    if (setup.id) {
      setup.id = null;
    }
  }

  function backToQuickstart() {
    isSetupExapnded = false;
    setup.isExpanded = false;
    if (setup.id) {
      setup.id = null;
    }
  }
</script>

{#if !isSetupExapnded}
  <SetupWrapper>
    <ExpandButton on:expandSetup={expandSetup} />
    <Actions {setup} on:startWorkout />
  </SetupWrapper>
{:else}
  <SetupWrapper>
    <BackToQuickstart on:backToQuickstart={backToQuickstart} />
    <Name bind:name={setup.name} />
    <Prepare bind:prepare={setup.prepare} />
    <Container>
      <h4 class="text-base text-center pt-4">rft</h4>
      <div class="w-full flex justify-center items-center">
        <textarea
          bind:value={setup.description}
          class="focus:ring-4 ring-gray-500 focus:outline-none ring-opacity-30 font-semibold p-2 bg-gray-600 border-0 rounded-xl w-full h-40"
          {placeholder}
          rows="5"
        />
      </div>
    </Container>
    <Actions {setup} on:startWorkout on:expandSetup={expandSetup} />
  </SetupWrapper>
{/if}

<style>
  /* width */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 100vh;
    background: rgb(56, 56, 56);
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgb(49, 47, 47);
    border-radius: 100vh;
    border: 2px solid rgb(63, 63, 63);
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: rgb(12, 12, 12);
  }

  ::-webkit-resizer {
    border-width: 0px;
    border-style: solid;
    border-color: transparent rgb(66, 66, 66) rgb(66, 66, 66) transparent;
    background: transparent;
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }
</style>
